import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import AreaUnitToggle from '../AreaUnitToggle';
import rootStore from '../../features/rootStore/RootStore';

const PageHeader = observer(() => {
  const { t } = useTranslation();
  const { areaUnitStore, userStore } = rootStore;
  const { combinedData } = userStore;
  const { areaUnit, setAreaUnit } = areaUnitStore;
  const currency = combinedData.stripeCustomer?.currency;
  const showAreaUnitToggle = !currency;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 1, sm: 3 },
        pb: { xs: 3, sm: '33px' },
      }}
    >
      <Typography variant="h1">{t('plan-select.header.title')}</Typography>
      <Typography variant="h3">{t('plan-select.header.subtitle')}</Typography>
      {showAreaUnitToggle && (
        <AreaUnitToggle
          showPlaceholder={combinedData.loading}
          areaUnit={areaUnit}
          onAreaUnitChange={setAreaUnit}
        />
      )}
    </Box>
  );
});

export default PageHeader;
